import {Box, Grid, styled} from "@mui/material";

//error 지월것들
export const StyledCreateSection = styled(Box)(
  ({theme}) => `
  width: 100%;
`
);

export const StyledFormContainer = styled(Box)(
  ({theme}) => `
  width: 100%;
`
);

export const StyledCreateFormContainer = styled(Box)(
  ({theme}) => `
  width: 100%;
`
);

export const StyledInputList = styled(Box)(
  ({theme}) => `
  display: flex;
  flex: 1 0 50%;
`
);

//note 수정본
export const FormSection = styled(Box)(
  ({theme}) => `
  position: relative;
  margin-top: 32px;

`
);
export const FormContents = styled(Grid)(({theme}) => ({
  width: "100%",
  padding: "48px 16px",
  backgroundColor: theme.palette.background.paper,
  "& .MuiFormControl-root": {
    width: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "24px 8px",
  },
}));

export const StyledTrustCheckContainer = styled(Grid)(
  ({theme}) => `
  width: 100%;
  margin-top: 60px;
`
);

export const StyledTrustCheck = styled(Grid)(({theme}) => ({
  position: "relative",
  display: "flex",
  width: "84%",
  padding: "36px 0",
  borderRadius: "16px",
  // border: `2px dotted ${theme.palette.warning.light}`,
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));
export const ReliabilityToggle = styled(Box)(
  ({theme}) => `
  position:absolute;
  top: -42px;
  
  `
);

export const InputFileContainer = styled(Grid)(({theme}) => ({
  width: "100%",
  padding: "48px 16px",
  backgroundColor: theme.palette.background.paper,

  [theme.breakpoints.down("sm")]: {
    padding: "24px 8px",
  },
  "& .MuiFormControl-root": {
    width: "100%",
  },
  "& .css-1vam7s3-MuiGrid-root": {
    [theme.breakpoints.down("sm")]: {
      flexWrap: "nowrap",
      padding: "16px 0",
      borderBottom: `1px solid ${theme.palette.warning.light}`,
    },
    // "& label": {
    //   whiteSpace: "nowrap",
    // },
  },
}));
